<script>
import Layout from '../../layouts/main';
import PageHeader from '../../components/page-header'
import { deliveryZoneService } from '../../services';
import { error_message, success_message, get_user } from "../../Helper/helper";
import config from "../../config";
import { required } from "vuelidate/lib/validators";

export default {
  components: { Layout, PageHeader },
  data() {
    return {
      config: config,
      zones:"",
      typeform: {
        pincode: "",
        zone_id:'',
        status: "1",
      },
      typesubmit: false,
    };
  },
  validations: {
    typeform: {
      pincode: {
        required
      },
      zone_id: {
        required
      }
    }
  },
  mounted() {
    this.vendor_id = get_user().vendor_id || 40818;
    this.getDeliveryZones();
  },
  methods: {
    getDeliveryZones(){
      var requestParams = {
          search: '',
          status: '1',
          sortBy: 'name',
          orderBy: "asc",
      }
      deliveryZoneService.getDeliveryZone(requestParams)
      .then(response => {
        console.log('response',response)
        if (response.data.code === 200) {
          this.zones = response.data.result.data;
          console.log('zone',this.zones)
        } else {
          this.zones = [];
        }
      });
    },
    contactNumber(evt) {
      let val1 = evt.target.value;
      if (!(evt.keyCode == 43 || (evt.keyCode >= 48 && evt.keyCode <= 57))) {
        evt.preventDefault();
      }
      let partlen = val1.split("+").length - 1;
      if (evt.keyCode == 43 && partlen > 0) {
        evt.preventDefault();
      } else if (evt.keyCode == 43 && (evt.target.selectionStart !== undefined && evt.target.selectionStart !== 0)) {
        evt.preventDefault();
      }
    },
    typeForm(e) {
      this.$v.$touch();
      if (this.$v.typeform.$invalid) {
        return;
      }
      else {
        deliveryZoneService.addPostalCode(this.typeform)
          .then(response => {
            if (response.data.code === 200) {
              success_message(response.data.message);
              this.$router.push({ name: "postal-list" });
            } else {
              error_message(response.data.message);
            }
          });
      }
    },
  }
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between icon-main-page">
          <div class="page-title-left avatar-main-icon">
            <div class="avatar-xs mr-3">
              <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                <i class="bx bx-map-alt"></i>
              </span>
            </div>
            <div class="report-tag">
              <h4 class="mb-0 font-size-18">{{ trans.get('__JSON__.Add Postal Code') }}</h4>
              <p>
                <router-link :to="{ name: 'postal-list' }">{{ trans.get('__JSON__.Postal Codes') }}</router-link> > {{trans.get('__JSON__.Add Postal Code')}}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-form action="#" @submit.prevent="typeForm">
          <div class="card">
            <div class="card-body">
              <p class="card-title-desc"></p>
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="required">{{trans.trans("__JSON__.Delivery Zone")}}</label>
                    <select class="custom-select" v-model="$v.typeform.zone_id.$model" id="zone_id"
                      name="zone_id" 
                      :class="{ 'is-invalid': $v.typeform.zone_id.$error }">
                      <option value="">
                        {{ trans.get("__JSON__.Select Delivery Zone") }}
                      </option>
                      <option v-for="zone in zones" :value="zone.id" :key="zone.id">
                        {{ zone.name }}
                      </option>
                    </select>
                    <div v-if="$v.typeform.zone_id.$error" class="invalid-feedback">
                      <span v-if="!$v.typeform.zone_id.required">{{trans.get("__JSON__.Please select Delivery zone")}}</span>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="control-label required">{{ trans.get('__JSON__.Postal Code') }}</label>
                    <input maxlength="5" minlength="5" id="pincode" v-model="$v.typeform.pincode.$model" type="text"
                      class="form-control" :placeholder="trans.get('__JSON__.Postal Code')" name="pincode"
                      :class="{ 'is-invalid': $v.typeform.pincode.$error }" @keypress="contactNumber($event)" />
                    <div v-if="$v.typeform.pincode.$error" class="invalid-feedback">
                      <span v-if="!$v.typeform.pincode.required">{{ trans.get('__JSON__.Please enter postal code')}}</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 vendor-status">
                  <b-form-group id="input-group-2" :label="trans.get('__JSON__.Status')" label-for="Status">
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="swtich-data">
                          <label class="switch">
                            <input type="checkbox" id="togBtn" class="switch-on" name="status" v-model="typeform.status"
                              true-value="1" false-value="0" />
                            <div class="slider round">
                              <span class="on">{{ trans.get('__JSON__.Active') }}</span>
                              <span class="off">{{ trans.get('__JSON__.Inactive') }}</span>
                            </div>
                          </label>
                        </div>
                      </div>
                    </div>
                  </b-form-group>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-6">
                  <button type="submit" class="btn btn-primary mr-1 mt-3">{{ trans.get('__JSON__.Add Delivery Zone')}}</button>
                  <b-button @click="$router.go(-1)" type="button" variant="secondary"
                    class="mt-3">{{ trans.get('__JSON__.Cancel') }}</b-button>
                </div>
              </div>
            </div>
          </div>
        </b-form>
      </div>
    </div>
  </Layout>
</template>